// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__1_z-8","tag__icon":"styles_tag__icon__X72-o","tag__body":"styles_tag__body__2SoAK","card":"styles_card__2daHu","pointer":"styles_pointer__1iUXz"};